import { FieldArray } from "formik";
import { Button, Card, CardBody, CardHeader, Table } from "reactstrap";
import SelectField from "../Utils/SelectField";
import InputField from "../Utils/InputField";
import { TablesWithoutBorders } from "../../pages/Tables/BasicTables/BasicTablesCode";
import { isEmptyOrInvalidFieldForCommission } from "./Constants/ModifyDataFunctions";
import {
  ChargesDropDownOptions,
  CommissionTypeDropDownOptions,
} from "./Constants/DropdownOptions";
import { useEffect } from "react";

export const SettlementCommissionRules = ({
  values,
  setTouched,
  touched,
  errors,
  initialValues,
  setFieldValue,
  handleChange,
  getPolicyData,
}) => {
  const onResetRow = (index) => {
    values.commissionRules[index].charge = "";
    values.commissionRules[index].type = "";
    values.commissionRules[index].value = "";
    setFieldValue(`commissionRules[${index}].charge`, "");
    setFieldValue(`commissionRules[${index}].type`, "");
    setFieldValue(`commissionRules[${index}].value`, "");
  };
  useEffect(() => {
    if ("commissions" in getPolicyData) {
      values.commissionRules = [];
      getPolicyData.commissions.forEach((resp, index) => {
        values.commissionRules.push({
          charge: { value: resp.chargeType, label: resp.chargeType },
          type: { value: resp.commissionType, label: resp.commissionType },
          value: resp.commissionValue,
        });
      });
    }
  }, [getPolicyData]);

  return (
    <FieldArray name="commissionRules">
      {({ push, remove }) => {
        const lastIndex = values.commissionRules.length - 1;
        if (lastIndex === -1) {
          push({ charge: "", type: "", value: "" });
          setTouched({
            ...touched,
            commissionRules: {
              ...touched.commissionRules,
              [lastIndex]: { charge: false, type: false, value: false },
            },
          });
        }
        return (
          <>
            <div className="align-items-center d-flex">
              <h4 className="card-title mb-0 flex-grow-1 mt-3">
                Commission Rules
              </h4>
            </div>
            <CardBody>
              <div className="live-preview">
                <div className="table-responsive">
                  <Table className="table-borderless align-middle table-nowrap mb-0">
                    <thead>
                      <tr>
                        <th scope="col " style={{ width: "25%" }}>
                          Charges<span className="text-danger ms-1">*</span>
                        </th>
                        <th scope="col" style={{ width: "25%" }}>
                          Commission Type
                          <span className="text-danger ms-1">*</span>
                        </th>
                        <th scope="col " style={{ width: "25%" }}>
                          Commission Value
                          <span className="text-danger ms-1">*</span>
                        </th>
                        <th scope="col" style={{ width: "25%" }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {values?.commissionRules?.length === 0 ? (
                        <tr className="default-height">
                          <td colSpan={4} className="text-center">
                            No Commission Rules
                          </td>
                        </tr>
                      ) : (
                        values?.commissionRules?.map((val, index) => {
                          return (
                            <tr key={index}>
                              <td className="w-lg">
                                <SelectField
                                  className={
                                    (touched.commissionRules &&
                                      touched.commissionRules[index] &&
                                      !values.commissionRules[index].charge) ||
                                    false
                                      ? "error-input"
                                      : ""
                                  }
                                  name={`commissionRules[${index}].charge`}
                                  placeholder={"Select"}
                                  value={values.commissionRules[index]?.charge}
                                  handleChange={(selectedValue) => {
                                    (values.commissionRules[index].charge =
                                      selectedValue),
                                      setFieldValue("charge", selectedValue);
                                  }}
                                  options={ChargesDropDownOptions}
                                  isRVStyle={true}
                                />
                              </td>
                              <td>
                                <SelectField
                                  className={
                                    (touched.commissionRules &&
                                      touched.commissionRules[index] &&
                                      !values.commissionRules[index].type) ||
                                    false
                                      ? "error-input"
                                      : ""
                                  }
                                  name={`commissionRules[${index}].type`}
                                  placeholder={"Select"}
                                  value={values.commissionRules[index]?.type}
                                  handleChange={(selectedValue) => {
                                    (values.commissionRules[index].type =
                                      selectedValue),
                                      setFieldValue("type", selectedValue);
                                  }}
                                  options={CommissionTypeDropDownOptions}
                                  isRVStyle={true}
                                />
                              </td>
                              <td>
                                <InputField
                                  name={`commissionRules[${index}].value`}
                                  className={
                                    (touched.commissionRules &&
                                      touched.commissionRules[index] &&
                                      !values.commissionRules[index].value) ||
                                    false
                                      ? "is-invalid"
                                      : ""
                                  }
                                  placeholder="Enter Value"
                                  type="text" // use text to prevent touchpad scroll increment
                                  handleChange={(e) => {
                                    // allow only numbers
                                    const value = e.target.value.replace(/\D/g, "");
                                    handleChange({
                                      target: {
                                        name: `commissionRules[${index}].value`,
                                        value,
                                      },
                                    });
                                  }}
                                  value={
                                    values.commissionRules[index].value || ""
                                  }
                                  invalid={
                                    errors.commissionRules &&
                                    errors.commissionRules[index] &&
                                    touched.commissionRules &&
                                    touched.commissionRules[index] &&
                                    touched.commissionRules[index].value
                                      ? true
                                      : false
                                  }
                                  onKeyDown={(e) => {
                                    // prevent arrow up/down from incrementing
                                    if (
                                      e.key === "ArrowUp" ||
                                      e.key === "ArrowDown"
                                    )
                                      e.preventDefault();
                                  }}
                                />
                              </td>
                              <td>
                                {index === 0 && (
                                  <i
                                    className="ri-add-circle-line text-danger cursor-pointer fs-5 me-3"
                                    onClick={() => {
                                      const lastIndex =
                                        values.commissionRules.length - 1;
                                      if (
                                        lastIndex === -1 ||
                                        !isEmptyOrInvalidFieldForCommission(
                                          lastIndex,
                                          values
                                        )
                                      ) {
                                        push({
                                          charge: "",
                                          type: "",
                                          value: "",
                                        });
                                        setTouched({
                                          ...touched,
                                          commissionRules: {
                                            ...touched.commissionRules,
                                            [lastIndex]: {
                                              charge: false,
                                              type: false,
                                              value: false,
                                            },
                                          },
                                        });
                                      }
                                    }}
                                  ></i>
                                )}
                                {index === 0 ? (
                                  <i
                                    className="ri-eraser-line text-danger cursor-pointer fs-5"
                                    onClick={() => onResetRow(index)}
                                  ></i>
                                ) : (
                                  <i
                                    className="ri-delete-bin-5-line text-danger cursor-pointer fs-5"
                                    onClick={() => remove(index)}
                                  ></i>
                                )}
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>
            </CardBody>
          </>
        );
      }}
    </FieldArray>
  );
};
